import styled from 'styled-components'

export const EmptyContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-grow: 2;
  flex-basis: auto;
`

export const Container = styled.div`
  position: relative;
  width: 100%;
  overflow: auto;

  ::-webkit-scrollbar:horizontal {
    display: block;
  }
`
